const requireModule = require.context('.', false, /\.store\.js$/u);
const result = {};
for (const filename of requireModule.keys()) {
    const key = filename.replace(/(\.\/|\.store\.js)/gu, '');
    const value = requireModule(filename).default ?? requireModule(filename);
    result[key] = value;
}

export default result;